import React, { useState, useEffect, useRef } from 'react';
import {
  IconButton,
  OutlinedInput,
  InputAdornment,
  Skeleton,
  Avatar,
  Typography,
  Box,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css';

import { fetchBranchMenus } from '../../functions/menu';
import AxiosPrivate from '../../functions/axios/axiosPrivate';

import HeaderCard from './HeaderCard';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';

const Header = ({ setSearchValue, searchValue }) => {
  const [menuData, setMenuData] = useState([]);
  const [menuCategories, setMenuCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [activeMenu, setActiveMenu] = useState('All');
  console.log('active menu', activeMenu)
  const [activeIndex, setActiveIndex] = useState(0);
  const [isEnd, setIsEnd] = useState(false);
  
  const swiperRef = useRef(null);

  const {
    currentBranch: { id },
  } = useSelector((state) => state.branch);

  /* ================= FETCH DATA ================= */

  useEffect(() => {
    if (!id) return;

    const loadMenus = async () => {
      const res = await fetchBranchMenus(id);
      setMenuData(res.data.data || []);
    };

    loadMenus();
  }, [id]);
   console.log('Categories', menuCategories)
  useEffect(() => {
    if (!menuData.length) return;

    const fetchCategories = async () => {
      setLoading(true);
      try {
        const res = await AxiosPrivate.get(
          `/restaurant/categories-in-menu/${menuData[0]?.id}`
        );
        setMenuCategories(res.data.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [menuData]);

  /* ================= SWIPER HANDLERS ================= */

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
    setIsEnd(swiper.isEnd);
  };

  const goNext = () => swiperRef.current?.slideNext();
  const goPrev = () => swiperRef.current?.slidePrev();

  /* ================= RENDER ================= */

  return (
    <div>
      {/* ================= CATEGORY SLIDER ================= */}
      <div className="relative flex items-center ">
        {!loading && (
          <>
            <Swiper
              modules={[Navigation, A11y]}
              spaceBetween={12}
              slidesPerView={4}
              watchOverflow
              grabCursor
              speed={400}
              breakpoints={{
                640: { slidesPerView: 4 },
                768: { slidesPerView: 6 },
                1024: { slidesPerView: 8 },
              }}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={handleSlideChange}
              className='!w-full'
            >
              {/* ALL */}
              {menuCategories.length > 0 && (
                <SwiperSlide key="all">
                  <div
                    onClick={() => setActiveMenu('All')}
                    className="cursor-pointer"
                  >
                    <Box
                      sx={{
                        position: 'relative',
                        height: 48,
                        width: 48,
                        mx: 'auto',
                      }}
                    >
                      <Avatar
                        src="https://i.pinimg.com/564x/a2/45/24/a24524c60d6ea16adf8cf6aad6b45e77.jpg"
                        alt="All"
                        sx={{ height: 48, width: 48 }}
                      />
                      {activeMenu === 'All' && (
                        <div className="absolute inset-0 bg-black/40 flex items-center justify-center rounded-full">
                          <CheckCircleIcon sx={{ color: '#fff' }} />
                        </div>
                      )}
                    </Box>
                    <h2 className="text-sm text-center font-semibold mt-1">
                      All
                    </h2>
                  </div>
                </SwiperSlide>
              )}

              {/* CATEGORIES */}
              {menuCategories.map((item) => (
                <SwiperSlide key={item.id}>
                  <HeaderCard
                    item={item}
                    loading={loading}
                    activeMenu={activeMenu}
                    setActiveMenu={setActiveMenu}
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* RIGHT ARROW */}
            {!isEnd && (
              <div
                onClick={goNext}
                className="absolute right-0 z-10 h-10 w-10 flex items-center justify-center bg-white shadow-lg rounded-full cursor-pointer"
              >
                <ArrowForwardIosIcon fontSize="small" />
              </div>
            )}

            {/* LEFT ARROW */}
            {activeIndex > 0 && (
              <div
                onClick={goPrev}
                className="absolute left-0 z-10 h-10 w-10 flex items-center justify-center bg-white shadow-lg rounded-full cursor-pointer"
              >
                <ArrowBackIosIcon fontSize="small" />
              </div>
            )}
          </>
        )}

        {/* ================= SKELETON ================= */}
        {loading &&
          Array.from({ length: 6 }).map((_, i) => (
            <Box key={i} className="mr-4">
              <Skeleton variant="circular" width={48} height={48} />
              <Skeleton width={50} sx={{ mt: 1 }} />
            </Box>
          ))}
      </div>

      {/* ================= SEARCH ================= */}
      <OutlinedInput
        sx={{ width: '100%', mt: 2 }}
        size="small"
        placeholder="Search menu items"
        onChange={(e) => setSearchValue(e.target.value)}
        value={searchValue || ''}
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={() => setSearchValue('')} edge="end">
              {searchValue && <CloseIcon />}
            </IconButton>
          </InputAdornment>
        }
      />
    </div>
  );
};

export default Header;
